import { useEffect, useState } from 'react';

import { entityStatusService } from '../../../services/entityStatusService';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { EntityStatus } from '../../../constants/entityStatus';
import { UnconfiguredSettingsType } from '../../../constants/unconfiguredSettings';
import {
  SolutionType,
  SOLUTION_TYPE,
} from '../../../../shared/constants/user-info/solutionType';

const solutionToServiceMap = {
  [SOLUTION_TYPE.NUTRITION]: entityStatusService.getNutritionStatusDetails,
  [SOLUTION_TYPE.SCAN_IQ]: entityStatusService.getScanIqStatusDetails,
  [SOLUTION_TYPE.CHALLENGE]: entityStatusService.getChallengeStatusDetails,
};

export const useStatusDetails = (solution: SolutionType) => {
  const [status, setStatus] = useState<EntityStatus | null>(null);
  const [unconfigured, setUnconfigured] = useState<UnconfiguredSettingsType[]>([]);

  const { loggedInUser, getEntityId } = loggedInUserDataStore;

  const getStatusDetails = async () => {
    const entityId = getEntityId();
    const service = solutionToServiceMap[solution];

    const statusDetails = await service(entityId);

    setStatus(statusDetails.status);
    setUnconfigured(statusDetails.unconfigured || []);
  };

  useEffect(() => {
    getStatusDetails();
  }, [loggedInUser, solution]);

  return { status, unconfigured, getStatusDetails };
};
